import React, { useEffect, useState } from "react";
import s from './listeningAnalysis.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import {MyInput} from '../components/Utilities/MyInput';
import MyTooltip from '../components/Utilities/MyTooltip';

import {GreenButton, BlueButton, RedButton} from '../components/MyButton';
import {
  useSearchParams
} from "react-router-dom";

import {modifiedDate} from '../middleware/dateControl';

export default function ListeningAnalysis() {
	const navigate = useNavigate();
	
	let [searchParams, setSearchParams] = useSearchParams();
	let limit = searchParams.get("limit");
		
	if (!limit) {
		limit = 20
	}
	
	let [userListenings, setUserListenings] = useState([]);
	let [searchId, setSearchId] = useState(null);
	
	const rerun = (resultId) => {
		let obj = {
			"resultId" : resultId,
			"isClearLog" : "1"
		};
		postData("listeningApi/processListening", obj, navigate)
	
	}
	
	const resend = (resultId) => {
		let obj = {
			"resultId" : resultId
		};
		postData("listeningApi/resendListeningResult", obj, navigate)
	
	}
	
	const searchByUserId = () => {
		getData('userListeningApi/searchHistoryByUserId?id=' + searchId + '&limit=' + limit, navigate)
			.then(res => {
				setUserListenings(res.data);
			}
		);
	}
	
	const searchByTaskId = () => {
		getData('userListeningApi/searchHistoryByTaskId?id=' + searchId + '&limit=' + limit, navigate)
			.then(res => {
				setUserListenings(res.data);
			}
		);
	}	
	
	const searchByResultId = () => {
		getData('userListeningApi/searchHistoryByResultId?id=' + searchId + '&limit=' + limit, navigate)
			.then(res => {
				setUserListenings(res.data);
			}
		);
	}
	
	const searchByUsername = () => {
		getData('userListeningApi/searchHistoryByUsername?username=' + searchId + '&limit=' + limit, navigate)
			.then(res => {
				setUserListenings(res.data);
			}
		);
	}
	
	useEffect(() => {
		
	}, []);
	
	return (<div>
	
		<div style={{margin:"10px 0", fontSize:"0.8rem"}}>
			<div style={{display:"flex", margin:"10px", padding:"10px", gap:"10px"}}>
				
				<div style={{display:"flex"}}>
					<MyInput inputLabel={"Search"} dataInput={searchId} changeAction={(e)=>{
						setSearchId(e)
					}} />
					
					<div style={{display:"flex", gap:"5px"}}>
						<div>
							<GreenButton isEnabled={true} clickedAction={searchByUserId} bText="By User ID" />	
						</div>
						<div>
							<GreenButton isEnabled={true} clickedAction={searchByTaskId} bText="By Task ID" />
						</div>	
						<div>
							<GreenButton isEnabled={true} clickedAction={searchByResultId} bText="By Result ID" />
						</div>
						<div>
							<GreenButton isEnabled={true} clickedAction={searchByUsername} bText="By Username" />
						</div>		
					</div>		
				</div>		
				
				
			<MyTooltip msg={"&lt;page&gt;" +
											"listeningAnalysis.js<br/><br/>" +
											"&lt;components&gt;<br/>" +
											"X<br/>"} /> 
				
			</div>
		
			<div style={{display:"flex", gap:"10px", margin:"10px 10px 0 10px"}}>
				<div style={{flex: '0 0 80px'}}>Result Id</div>
				<div style={{flex: '0 0 80px'}}>Task Id</div>
				<div style={{flex: '0 0 80px'}}>Student Id</div>
				<div style={{flex: '0 0 80px'}}>Status</div>
			</div>
			{
				userListenings.map((d, indexD) => (<div><div key={indexD + "userListenings"} style={{display:"flex", gap:"10px", margin:"10px", alignItems:"center"}}>
					
						<div style={{flex: '0 0 80px'}}>{d.id}</div>
						<div style={{flex: '0 0 80px'}}>{d.taskId}</div>
						<div style={{flex: '0 0 80px'}}>{d.userId}</div>
						<div style={{flex: '0 0 80px'}}>{d.status}</div>
						<div style={{flex: '0 0 80px'}}>
							
							<Link className={s.detailButton} to={`/listening-partb/${d.id}`} target="_blank" rel="noopener noreferrer">
								View
							</Link>
						
						</div>	
						<div style={{flex: '0 0 80px'}}>
							<div>
								<GreenButton isEnabled={true} clickedAction={()=>rerun(d.id)} bText={"Rerun"} />
							</div>
						
						</div>	
						<div style={{flex: '0 0 80px'}}>
							<div>
								<GreenButton isEnabled={true} clickedAction={()=>resend(d.id)} bText={"resend"} />
							</div>
						
						</div>
					
					</div>
				</div>))
			}
		
		</div>
	
	</div>);
}

